<!-- カードのヘッダー -->
<div class="d-flex align-items-center clearfix">
  <div class="mail_title-text" placement="bottom" ngbTooltip="{{ mailInfo.title }}" [disableTooltip]="!showTooltip"
    container="body">
    <div class="margin-right-5 d-inline">
      <app-user-focus-star [mailInfo]="mailInfo" [mailType]="mailType" [page]="page"></app-user-focus-star>
    </div>
    <app-tag-area
      [mailType]="mailType" [mailInfo]="mailInfo" [page]="page"
      [offers]="sharedAccountOffers" [offeredMailIds]="offeredMailIds" [haveSkillList]="haveSkillList" [searchParams]="searchParams">
    </app-tag-area>
    <span [innerHTML]=" mailInfo
                          | setTitleString: baseKeywords
                          | highlightSearchedKeyword: searchParams"></span>
  </div>
  <div class="reject-tag" *ngIf="!!rejectReason" [innerHTML]='this.rejectReasonText()'></div>
</div>
